import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { VpButton, VpDialogActions, VpDialogTitle, VpDialogContent } from '../../';

const VpBudgetErrorDialog = ({ open = false, data = null, onClose = null, onIncreaseBudget = null }) => {
  if (!data) return null;

  const formatCurrency = (cents) => cents !== null ? `$${(cents / 100).toFixed(2)}` : 'N/A';
  const hasDetailedData = data.budget !== null;

  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
      <VpDialogTitle leftContent="Insufficient Budget" onClose={onClose} />
      <VpDialogContent>
        <Stack spacing="20px">
          <Typography variant="body1">
            {data.campaignName ? (
              <>
                The campaign <strong>{data.campaignName}</strong> does not have sufficient budget for this order.
              </>
            ) : (
              'The campaign does not have sufficient budget for this order.'
            )}
          </Typography>
          
          {hasDetailedData ? (
            <Box sx={{ backgroundColor: '#f5f5f5', p: 2, borderRadius: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
                Budget Details:
              </Typography>
              
              <Stack spacing={1}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2">Total Budget:</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {formatCurrency(data.budget)}
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body2">Already Spent:</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {formatCurrency(data.spent)}
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #e0e0e0', pt: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>Available Budget:</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {formatCurrency(data.available)}
                  </Typography>
                </Box>
                
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                  <Typography variant="body2">This Order Requires:</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 500, color: '#d32f2f' }}>
                    {formatCurrency(data.requested)}
                  </Typography>
                </Box>
                
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  backgroundColor: '#fff3e0', 
                  p: 1, 
                  borderRadius: 1, 
                  mt: 1 
                }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>Shortfall:</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: '#d32f2f' }}>
                    {formatCurrency(data.shortfall)}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          ) : (
            <Box sx={{ backgroundColor: '#fff3e0', p: 2, borderRadius: 1 }}>
              <Typography variant="body2">
                Please increase your campaign budget to proceed with this order.
              </Typography>
            </Box>
          )}

          <VpDialogActions fullWidth>
            <Stack direction="row" justifyContent="space-between" width="100%">
              <VpButton color="neutral" variant="contained" onClick={onClose}>
                Cancel
              </VpButton>
              <VpButton variant="contained" onClick={onIncreaseBudget}>
                Increase Budget
              </VpButton>
            </Stack>
          </VpDialogActions>
        </Stack>
      </VpDialogContent>
    </Dialog>
  );
};

VpBudgetErrorDialog.propTypes = {
  open: PropTypes.bool,
  data: PropTypes.shape({
    budget: PropTypes.number,
    spent: PropTypes.number,
    available: PropTypes.number,
    requested: PropTypes.number,
    shortfall: PropTypes.number,
    campaignId: PropTypes.string,
    campaignName: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onIncreaseBudget: PropTypes.func,
};

export default VpBudgetErrorDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpBudgetErrorDialog/VpBudgetErrorDialog.jsx